import btnOpHome from "./template";
import imgSrc from "../../../img/quiz.png";
import BtnHomeOpBase from "../abstracts/btnHomeOpBase";
import ModalQuiz from "../modals/modal-quiz/modalQuiz";
import I18n from "../../i18n";

export default class BtnQuiz extends BtnHomeOpBase{
    
    private static idBtn = "btn-quiz";
    private static labelBtn = "Quiz"
    private static elementToRender = btnOpHome(BtnQuiz.idBtn,BtnQuiz.labelBtn,imgSrc);
    private modalQuiz:ModalQuiz;

    constructor(protected container:HTMLElement){
        super(BtnQuiz.idBtn,container,BtnQuiz.elementToRender);
        this.createModalQuiz();
    }

    private createModalQuiz(){
        this.modalQuiz = new ModalQuiz(this.container);
        this.modalQuiz.render();
    }

    public clickAction() {
        this.elementRendered.addEventListener("click",()=>{
            this.modalQuiz.show();
            this.modalQuiz.loadBody();
            I18n.exec();
        });
    }

}